import reducers from './reducers';
import * as accessActions from './actions';
import * as accessTypes from './types';

export { accessActions, accessTypes };

export default reducers;
